import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useAppSelector } from '../../../redux/hooks';
import { selectedUnit } from '../../../redux/reducers/unitSlice';
import {
  lockedHeaderBadgeColors,
  resolveUnitBaseColor,
  unitHeaderBadgeColors,
} from '../../../businessLogicService/StudentDashboardAux/getColorByUnit';
import { UnitHeaderTargetIcon } from '../DashboardUnitHeaderIcons/UnitHeaderTargetIcon';

interface Props {
  type: DashboardConnectorType;
  label: string;
}

export const TargetMilestoneBadge: FC<Props> = ({ type, label }) => {
  const unit = useAppSelector(selectedUnit);
  const isLocked = type === 'locked';
  const colors = isLocked ? lockedHeaderBadgeColors : unitHeaderBadgeColors[resolveUnitBaseColor(unit?.name)];

  return (
    <div className="tw-relative tw-h-[65px] tw-w-[55px]">
      <UnitHeaderTargetIcon
        bubble={false}
        iconOpacity={isLocked ? 0.5 : undefined}
        className="tw-absolute tw-left-0 tw-top-0 tw-h-[56px] tw-w-[55px]"
        colors={colors}
      />
      <div className="tw-absolute tw-left-1/2 tw-top-[44px] tw-h-[18px] tw-w-[75px] tw--translate-x-1/2">
        <svg className="tw-absolute tw-inset-0" width="75" height="18" viewBox="0 0 75 18" fill="none">
          <rect width="75" height="18" rx="6" className={colors.ring} />
          <rect x="2" y="2" width="71" height="14" rx="4" fill="#FEFBF9" />
        </svg>
        <span
          className={`tw-relative tw-flex tw-h-full tw-items-center tw-justify-center tw-text-[11px] tw-font-bold tw-uppercase tw-leading-none tw-font-['Atkinson_Hyperlegible'] ${colors.count}`}
        >
          {label}
        </span>
      </div>
    </div>
  );
};
